module.exports = __webpack_public_path__ + "static/media/logo.3bfd4979.svg";